import { Box, InputBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";

const MEcheckEditAmountToMove = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    const [amountToMove,setAmountToMove] = useState(0);

    useEffect(() => {
        if(props.toAndFromData &&props.toAndFromData.fromRow && props.toAndFromData.fromRow.amount) {
            setAmountToMove(props.toAndFromData.fromRow.amount);
        }
    },[props.toAndFromData])


    const handleClose = (toMove) => {
        if(toMove){
            props.handleClose(toMove,amountToMove);
        } else {
            props.handleClose(toMove,0);
        }
    }

    return(
        <SHModal
            open={props.open}
            onClose={() => handleClose(false)}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("move_amount")}</Subheading>
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    pb:1,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                <Box 
                    sx={{
                        width:1,
                    }}
                >
                    
                    <Box
                        sx={{
                            height:40,
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            display:"flex",
                            alignItems:'center',
                            pl:0.5,
                            borderRadius:5,
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                lineHeight:"32px",
                                borderRadius:4,
                                px:2,
                                // width:100,
                                background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            }}
                        >
                            <Text>{t("amount")}</Text>
                        </Box>
                        <InputBase 
                            autoFocus
                            value={amountToMove}

                            onChange={(e) => {
                                const input = e.target.value;

                                // Only allow digits (or empty string)
                                if (/^\d*$/.test(input)) {
                                    // Allow empty input
                                    if (input === '') {
                                        setAmountToMove(''); // Presumably you want to keep it empty
                                        return;
                                    }

                                    const numericInput = parseInt(input, 10);

                                    // Only allow numbers >= 1
                                    if (numericInput >= 1) {
                                        const maxAmount = props.toAndFromData.fromRow.amount;
                                        setAmountToMove(Math.min(numericInput, maxAmount));
                                    }
                                }
                            }}
                            sx={{
                                height:40,
                                flex:1,
                                px:2,
                                fontSize:14,
                                lineHeight:"40px",
                                fontFamily:"Roboto",
                            }}
                        />
                    </Box>
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton 
                    isCancel={true} 
                    className={"always-visible"} 
                    onClick={() => {
                        handleClose(false);
                    }} 
                    color="primary" 
                    variant="text" 
                    startIcon={<ArrowRightAltIcon/>}
                >
                    {t("cancel")}
                </Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained" 
                    onClick={() => handleClose(true)}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MEcheckEditAmountToMove;
